import React, { FC } from 'react'
import times from 'lodash/times'
import { DraggableList, IDraggableListProps } from 'transfix-ui/components/DraggableList'
import { IOrderedShipmentStopFragment } from '../../graphql/OrderedShipmentStop'
import { ShipmentStopListItem } from './ShipmentStopListItem'
import { ShipmentStopListItemSkeleton } from './ShipmentStopListItemSkeleton'

interface IShipmentStopListProps extends Omit<IDraggableListProps, 'children'> {
  stops: IOrderedShipmentStopFragment[]
  /**
   * @default false
   */
  loading?: boolean
  /**
   * @default false
   */
  isDisabled?: boolean
  onDeleteStop: (shipmentStopId: string) => Promise<void>
}

const ROW_HEIGHT_PX = 88

/**
 * Give list minimum height based on number of rows
 */
const getMinHeight = (stops: IShipmentStopListProps['stops'] = []): number => {
  return ROW_HEIGHT_PX * stops.length
}

export const ShipmentStopList: FC<IShipmentStopListProps> = ({
  isDisabled = false,
  loading = false,
  onDeleteStop,
  stops = [],
  ...rest
}) => {
  const isDeleteHidden = stops.length < 2
  return (
    <DraggableList BoxProps={{ minHeight: getMinHeight(stops) }} isDisabled={isDisabled} {...rest}>
      {loading
        ? times(1).map(index => <ShipmentStopListItemSkeleton key={index} index={index} />)
        : stops.map((stop, index) => (
            <ShipmentStopListItem
              stop={stop}
              key={stop.id.toString()}
              index={index}
              hideIcon={isDisabled}
              isDragDisabled={isDisabled}
              isDeleteHidden={isDeleteHidden}
              onDeleteStop={onDeleteStop}
            />
          ))}
    </DraggableList>
  )
}
